import React from 'react';

function CodeEditorWithHighlight({ value, onChange, language, theme }) {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const getLineNumbers = () => {
    const lines = value.split('\n').length;
    return Array.from({ length: Math.max(lines, 1) }, (_, i) => i + 1).join('\n');
  };

  return (
    <div className="code-editor-wrapper">
      <div className="line-numbers">
        <pre>{getLineNumbers()}</pre>
      </div>
      
      <textarea
        className={`code-editor-simple ${theme}`}
        value={value}
        onChange={handleChange}
        placeholder="Start coding here..."
        spellCheck="false"
        autoCapitalize="off"
        autoComplete="off"
        autoCorrect="off"
      />
    </div>
  );
}

export default CodeEditorWithHighlight;